import { useFeatureFlag as useConfigCatFeatureFlag } from 'configcat-react';

import { FEATURE_FLAG_DEFAULTS, FeatureFlag } from '@/constants/feature-flags.ts';

import { useConfigCatUser } from '@/hooks/use-config-cat-user.ts';

import { useAuthStore } from '@/stores/auth-store.ts';

export const useFeatureFlag = (flag: FeatureFlag): { value: boolean; loading: boolean } => {
    const isAdmin = useAuthStore((state) => state.isAdmin);
    const user = useConfigCatUser();
    const defaultValue = FEATURE_FLAG_DEFAULTS[flag];
    const { value, loading } = useConfigCatFeatureFlag(flag, defaultValue, user);

    if (isAdmin) return { value: true, loading: false };

    return { value, loading };
};
